<table mat-table [dataSource]="gridData.productDetail" multiTemplateDataRows class="matTables productTable">
  <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
    <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
    <div *ngIf="column=='detail'"><th mat-header-cell *matHeaderCellDef class="package">&nbsp;</th></div>
    <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Ordered Quantity</th></div>
    <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="quantityBlock  text-center">Order UOM</th></div>
    <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Package Size</th></div>
    <div *ngIf="column=='totalPrice'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Total Amount</th></div>

    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='product'">
        <div class="order-info defaultCursor margin-l0">
          <p><span *ngIf="element.itemVendorName" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.itemVendorName}}</span> </p>
          <p class="grower-name" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.productName}}</p>
          <!--<p><span *ngIf="plAccess==true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUOM}}</span></p>
          <p> <span class="paymentTerm" *ngIf="plAccess == true && element.paymentTerms!='' && element.paymentTerms!=null && element.paymentTerms!=undefined">{{element.paymentTerms }}</span></p>-->
          <!--<p class="grower-name">{{element.itemNumber}}</p>-->
        </div>
      </div>
      <div *ngIf="column=='detail'" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED','showHideDetails text-center': element.lineStatus !=='CANCELLED' }">
        <ng-container *ngIf="element.lineStatus !=='CANCELLED';else elseBlock">
          <a (click)="showProductDetails(element);" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.isDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
        </ng-container>
        <ng-template #elseBlock>
          <ng-container class="text-center productDetailsFont">View Product Details</ng-container>
        </ng-template>
      </div>
      <div *ngIf="column=='quantity'" class="text-center largeTableTxt">
        <ng-container *ngIf="element.lineStatus !='CANCELLED'"> {{element.originalOrderQuantity | number:'1.4-4'}}</ng-container>
        <ng-container *ngIf="element.lineStatus=='CANCELLED'" class="disabledrow">Cancelled</ng-container>
      </div>
      <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.uom}}</div>
      <div *ngIf="column=='packageSize'" class="text-center largeTableTxt" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.packageSize}}</div>
      <div *ngIf="column=='totalPrice'" class="text-center largeTableTxt" [ngClass]="{ 'disabledrow': element.lineStatus =='CANCELLED' }">{{element.totalPrice | number:'1.2-2'}}</div>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div [style.display]="element.isDetailDisplayed ? 'block' : 'none'">
        <div class="cpp-prod-info">
          <table style="width:100%">
            <tbody>
              <tr>
                <th width="15%" class="text-left">Item # </th>
                <th width="17%"> GTIN </th>
                <th width="17%"> Product Line </th>
                <th width="17%"> Active Ingredients </th>
                <th width="17%"> Pallet Quantity </th>
                <th width="17%"> Restricted Use </th>
              </tr>
              <tr>
                <td width="15%" class="text-left"><p>{{element.itemNumber}}</p> </td>
                <td width="17%"><p>{{element.gtin}}</p></td>
                <td width="17%"><p>{{element.productLine}}</p> </td>
                <td width="17%"><p>{{element.activeIngredient}}</p> </td>
                <td width="17%"><p>{{element.palletQuantity | number:'1.4-4'}}</p> </td>
                <td width="17%"><p>{{element.restrictedUse}}</p> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;" [ngClass]="{ 'Cancelled': element.lineStatus =='CANCELLED' }"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>
<div *ngIf="gridData.productDetail == undefined || gridData.productDetail?.length == 0" class="noDataMsg">
  <p>No Record Found.</p>
</div>
